import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import TickerNumber from '../live/TickerNumber';
import SplitFlap from '../live/SplitFlap';
import Sparkline from '../live/Sparkline';

const { FiTrendingUp, FiTrendingDown, FiMinus } = FiIcons;

const trendColor = (trend) => {
  if (trend === 'up') return 'text-[#00C27A]';
  if (trend === 'down') return 'text-[#D71921]';
  return 'text-neutral-500';
};

const trendIcon = (trend) => {
  if (trend === 'up') return FiTrendingUp;
  if (trend === 'down') return FiTrendingDown;
  return FiMinus;
};

const KPICard = ({
  title,
  value,
  unit,
  target,
  trend = 'flat',
  trendValue,
  icon,
  accent = '#FFFFFF',
  onClick,
  clickable = false,
  subdued = false,
  animated,
  numericValue,
  tickerDigits = 6,
  tickerPrefix = '',
  tickerSuffix = '',
  flapText,
  flapWidth = 8,
  sparkValues,
  badge,
}) => {
  const Wrap = clickable ? 'button' : 'div';

  let valueNode;
  if (animated === 'ticker' && (numericValue !== undefined && numericValue !== null)) {
    valueNode = (
      <TickerNumber
        value={numericValue}
        digits={tickerDigits}
        prefix={tickerPrefix}
        suffix={tickerSuffix}
      />
    );
  } else if (animated === 'splitflap' && flapText !== undefined) {
    valueNode = <SplitFlap text={flapText} width={flapWidth} />;
  } else {
    valueNode = value;
  }

  return (
    <Wrap
      onClick={onClick}
      className={`group relative w-full text-left flex flex-col justify-between p-4 border transition-all overflow-hidden ${
        subdued ? 'border-white/5 bg-black' : 'border-white/10 bg-[#0A0A0A]'
      } ${clickable ? 'hover:border-[#D71921] cursor-pointer clickable-glow' : ''}`}
    >
      <div className="flex justify-between items-start mb-3">
        <div className="font-mono-tech text-[9px] uppercase tracking-[0.25em] text-neutral-500">
          {title}
        </div>
        {icon && (
          <div className="w-7 h-7 flex items-center justify-center border border-white/10" style={{ color: accent }}>
            <SafeIcon icon={icon} className="text-sm" />
          </div>
        )}
      </div>

      <div>
        <div className="flex items-baseline gap-2">
          <div className="font-doto text-3xl xl:text-4xl font-black leading-none text-white tracking-tight">
            {valueNode}
          </div>
          {unit && (
            <div className="font-mono-tech text-[10px] text-neutral-500 uppercase tracking-wider">
              {unit}
            </div>
          )}
        </div>

        <div className="flex items-center justify-between mt-3 font-mono-tech text-[10px] uppercase tracking-wider">
          {target && (
            <span className="text-neutral-600">
              TGT: <span className="text-neutral-400">{target}</span>
            </span>
          )}
          {trendValue && (
            <span className={`flex items-center gap-1 ${trendColor(trend)}`}>
              <SafeIcon icon={trendIcon(trend)} />
              {trendValue}
            </span>
          )}
        </div>
      </div>

      {sparkValues && sparkValues.length > 0 && (
        <div
          className="absolute left-0 right-0 bottom-0 h-[6px]"
          style={{ color: accent, opacity: 0.5 }}
        >
          <Sparkline values={sparkValues} width={240} height={6} />
        </div>
      )}

      {badge && (
        <div className="absolute top-2 right-2">{badge}</div>
      )}

      {clickable && (
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="font-mono-tech bg-[#D71921] text-white text-[8px] px-1.5 py-0.5 uppercase tracking-widest font-bold">
            Drill
          </div>
        </div>
      )}
    </Wrap>
  );
};

export default KPICard;
